import { useMemo } from 'react';
import { isDefined } from 'utils/tsHelpers';
import { useRestQuery } from 'utils/hooks/api';
import { LISTS_BY_ID_ENDPOINT } from 'api/ListsApi';
import { CompleteQuery } from 'modules/queryBuilder/types';

export const useListDetailsByIdQuery = (id: number | undefined) => {
  const {
    data = {},
    isLoading,
    isError: didError,
    isSuccess,
    refetch,
  } = useRestQuery(
    LISTS_BY_ID_ENDPOINT,
    { listId: id },
    { enabled: isDefined(id), refetchOnWindowFocus: false },
  );

  const { list = {} } = data;
  const searchQuery = useMemo<CompleteQuery>(() => list?.searchQuery, [list]);
  return {
    list,
    searchQuery,
    didError,
    isLoading,
    isSuccess,
    refetch,
  };
};
